export enum ArenaMatchReportType {
  Live = 'Live',
  Simulation = 'Sim',
}
